import { cx } from '@emotion/css';
import { translateText } from '@gm-commercial/translations';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import CloseIcon from '../../assets/closeIcon.svg?react';
import { Flex } from '../Flex';
import type { DataDisplayCardProps, DataLabel } from './DataDisplayCard.model';
import useStyles from './DataDisplayCard.styles';

const DataDisplayCard = ({
  dataImage,
  dataDisplayLabels,
  onClick,
  onClose,
  noBackground = false,
  width = '100%',
}: DataDisplayCardProps) => {
  const { classes } = useStyles();

  return (
    <Box
      className={cx(
        classes.displayCardRoot,
        !noBackground && classes.displayCardBackground
      )}
      style={{
        cursor: onClick ? 'pointer' : 'inherit',
        width: width,
      }}
      onClick={onClick}
      data-testid="data-display-cell"
    >
      <Box className={classes.imageColumn} data-testid="data-display-image">
        {dataImage}
      </Box>
      <Flex col className={classes.labelsColumn}>
        {dataDisplayLabels.map((dataLabel: DataLabel, index: number) => (
          <Box
            // biome-ignore lint/suspicious/noArrayIndexKey: labels are positional display rows with no identity of their own and may repeat (e.g. several "--" fallbacks), and the rows hold no state
            key={index}
            data-heap-redact-text={dataLabel.dataHeapRedact}
            data-testid={dataLabel.dataTestId}
            height="18px"
          >
            <Typography
              variant={dataLabel.typographyVariant ?? 'small_body_medium'}
              color={dataLabel.color}
            >
              {dataLabel.label}
            </Typography>
          </Box>
        ))}
      </Flex>
      {onClose && (
        <Box className={classes.closeIconColumn}>
          <CloseIcon
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation();
                e.preventDefault();
                onClose();
              }
            }}
            className={classes.closeIconButton}
            aria-label={translateText('common:close')}
          />
        </Box>
      )}
    </Box>
  );
};

export default DataDisplayCard;
